import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  ContentChild,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import * as _ from 'lodash';
import { BoardEvaluationExecutionService } from '../../../../services/boardEvaluationExecution.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-category-sidebar',
  templateUrl: './category-sidebar.component.html',
  styleUrls: ['./category-sidebar.component.css'],
})
export class CategorySidebarComponent
  implements OnInit, AfterViewInit, OnChanges
{
  @Input('criteriaList') criteriaList: any;
  @Input('activeCriteria') activeCriteria: any;
  @Input('answerDetails') answerDetails: any;
  @Input('question') question: any;
  @Output() selectedIndex = new EventEmitter();
  @Output() selectedCriteria = new EventEmitter();
  @Output() changeCriteriaDetails = new EventEmitter();
  @Input('assesseeListToExecute') assesseeListToExecute: any;

  public isOpened: boolean;
  public activeId: string;
  answerStatus: any;
  commentPanel: string = 'comments';
  // answerDetails : any;
  public commentEnable: any;
  subscribe: Subscription;
  questionStatus: Boolean = false;

  constructor(public boardExecutionService: BoardEvaluationExecutionService) {
    this.initialiseSubjectSubscription();
  }

  async initialiseSubjectSubscription() {
    this.subscribe =
      await this.boardExecutionService.commentsObservable.subscribe((res) => {
        this.commentEnable = res;
      });
  }

  ngOnInit() {
    this.changedActiveIds();
  }

  ngAfterViewInit() {
    this.bindAnswersToquestion();
    this.checkQuestionAnswerStatus();
  }

  ngOnChanges() {
    const self = this;
    // //console.log("answerDetails---- category",this.answerDetails);
    this.answerDetails = this.answerDetails;
    // //console.log('checking for the prvious category',self.activeCriteria)
    if (!_.isUndefined(self.activeCriteria)) {
      // //console.log('inside if condition')
      this.activeId = this.activeCriteria._id;
      this.criteriaList.forEach((element) => {
        if (element._id === self.activeId) {
          element.isOpened = true;
        } else {
          element.isOpened = false;
        }
      });
    } else {
      // //console.log('inside else function')
    }
    this.bindAnswersToquestion();
    this.checkQuestionAnswerStatus();

    if (!_.isUndefined(this.assesseeListToExecute)) {
      // console.log("assess",this.assesseeListToExecute , this.question)
      this.checkQuestionAnswered();
    }
  }

  bindAnswersToquestion() {
    var self = this;
    if (_.size(this.answerDetails)) {
      var index = _.findIndex(self.answerDetails, function (answer) {
        return _.get(answer, 'QuestionId') == self.question._id;
      });

      if (index >= 0) {
        //console.log("index", index);
        this.answerStatus = self.answerDetails[index].AnswerStatus
          ? self.answerDetails[index].AnswerStatus
          : 'Not Answered';
      } else {
        this.answerStatus = 'Not Answered';
      }
    } else {
      this.answerStatus = 'Not Answered';
    }
    //console.log("this.answerStatus",this.answerStatus)
  }

  changedActiveIds() {
    // //console.log("this.criteria categorymaster",this.criteriaList, _.first(this.criteriaList))
    this.activeId = _.get(_.first(this.criteriaList), '_id');
    // //console.log("this.activeId",this.activeId);
    this.criteriaList.forEach((element) => {
      if (element._id == this.activeId) {
        element.isOpened = true;
      } else {
        element.isOpened = false;
      }
    });
    this.bindAnswersToquestion();
  }

  selectedQues(data: any) {
    // //console.log("question id", data);
    const _this = this;
    this.criteriaList.forEach((element) => {
      element.EvaluationQuestion.forEach((ques) => {
        if (ques.EvaluationQuestionId._id == data) {
          ques.EvaluationQuestionId.isActive = true;
        } else {
          ques.EvaluationQuestionId.isActive = false;
        }
      });
    });
    this.selectedIndex.emit(data);
    this.bindAnswersToquestion();
    this.checkQuestionAnswerStatus();
  }

  changed(data) {
    const self = this;

    if (data.panelId == 'comments') {
      this.boardExecutionService.commentsEvent$.next(true);
    } else {
      this.boardExecutionService.commentsEvent$.next(false);

      //console.log("data category", data)
      this.criteriaList.forEach((element) => {
        if (element._id === data.panelId) {
          // self.activeId = element.CategoryId;
          // self.activeCategory = element;
          element.isOpened = data.nextState;
          this.selectedCriteria.emit(data);
        } else {
          element.isOpened = false;
        }
      });
      this.bindAnswersToquestion();
      this.checkQuestionAnswerStatus();
    }
  }

  checkQuestionAnswerStatus() {
    var self = this;
    _.forEach(this.criteriaList, function (criteria) {
      _.forEach(criteria.EvaluationQuestion, function (question) {
        if (_.size(self.answerDetails)) {
          // _.forEach(self.answerDetails, function(answer){
          //   if( _.get(_.get(question,'EvaluationQuestionId'), '_id') == answer.QuestionId){
          //     question.EvaluationQuestionId['answerStatus'] = answer.AnswerStatus
          //   }else{
          //     question.EvaluationQuestionId['answerStatus'] = "Not Answered"
          //   }
          // })

          var index = _.findIndex(self.answerDetails, function (answer) {
            return (
              _.get(_.get(question, 'EvaluationQuestionId'), '_id') ==
              _.get(answer, 'QuestionId')
            );
          });

          if (index >= 0) {
            question.EvaluationQuestionId['answerStatus'] =
              self.answerDetails[index].AnswerStatus;
          } else {
            question.EvaluationQuestionId['answerStatus'] = 'Not Answered';
          }
        } else {
          question.EvaluationQuestionId['answerStatus'] = 'Not Answered';
        }
      });
    });
    this.changeCriteriaDetails.emit(this.criteriaList);
  }

  commentsClicked(event) {
    this.boardExecutionService.commentsEvent$.next(event);
  }

  ngOnDestroy() {
    this.boardExecutionService.usersExecutionFormEvent$.next([]);
    this.subscribe.unsubscribe();
  }

  checkQuestionAnswered() {
    var totalSize = _.size(this.assesseeListToExecute);
    var count = 0;
    this.assesseeListToExecute.forEach((element) => {
      if (_.size(element.Answers) > 0) {
        var found = element.Answers.findIndex((answerElement) => {
          return (
            answerElement.QuestionId == this.question._id &&
            answerElement.AnswerStatus == 'Answered'
          );
        });
        // console.log("found",found)
        if (found >= 0) {
          count = count + 1;
        }
      }
    });

    if (count == totalSize) {
      this.questionStatus = true;
    } else {
      this.questionStatus = false;
    }
  }

  showQuestionAnsweresStatus(question) {
    // console.log("inside question", question)
    var totalSize = _.size(this.assesseeListToExecute);
    var count = 0;
    if (
      !_.isUndefined(this.assesseeListToExecute) &&
      _.size(this.assesseeListToExecute) > 0
    ) {
      this.assesseeListToExecute.forEach((element) => {
        if (_.size(element.Answers) > 0) {
          var found = element.Answers.findIndex((answerElement) => {
            return (
              answerElement.QuestionId == question.EvaluationQuestionId._id &&
              answerElement.AnswerStatus == 'Answered'
            );
          });
          // console.log("found",found)
          if (found >= 0) {
            count = count + 1;
          }
        }
      });

      if (!_.isUndefined(question)) {
        // console.log("count", count , totalSize)
        if (count == totalSize) {
          question.EvaluationQuestionId.answerStatus = 'Answered';
          // console.log("{'btn-success': true}", count , totalSize)
          return false;
        } else {
          question.EvaluationQuestionId.answerStatus = 'Not Answered';
          // console.log("{'btn-success': false}", count , totalSize)
          return true;
        }
      }
    }
  }
}
